export const spotlightMarketingPanelHeading = $localize`:marketingPanels|Spotlight marketing panel@@spotlightMarketingPanelHeading:Recommended for your basket.`;
export const thankYouPageMarketingPanelHeading = $localize`:marketingPanels|Thank You Page marketing panel@@thankYouPageMarketingPanelHeading:Level up your order.`;
export const spotlightSearchMarketingPanelHeading = $localize`:marketingPanels|Spotlight search marketing panel@@spotlightSearchMarketingPanelHeading:Go faster with these products.`;
export const spotlightBasketMarketingPanelHeading = $localize`:marketingPanels|Spotlight basket marketing panel@@spotlightBasketMarketingPanelHeading:Recommended for your basket.`;

export const mostReorderedProductsHeadingKeys = {
  lastNrOfDays: '{{lastNrOfDays}}',
  brandOrg: '{{brandOrg}}',
  orderType: '{{orderType}}',
};
export const mostReorderedProductsHeading = $localize`:@@mostReorderedProducts:Most ${mostReorderedProductsHeadingKeys.orderType} products in the ${mostReorderedProductsHeadingKeys.brandOrg} last ${mostReorderedProductsHeadingKeys.lastNrOfDays} days`;
export function getMostReorderedProductsHeading(
  lastNrOfDays: number,
  brandOrg: string,
  orderType: string,
): string {
  return mostReorderedProductsHeading
    .replace(
      mostReorderedProductsHeadingKeys.lastNrOfDays,
      lastNrOfDays.toString(),
    )
    .replace(mostReorderedProductsHeadingKeys.brandOrg, brandOrg)
    .replace(mostReorderedProductsHeadingKeys.orderType, orderType);
}
